import { SlideComponentHkcsQ3 } from '@/types/slide';
import { SlideComponentCreator } from './factory';

export class SlideComponentHkcsQ3Creator extends SlideComponentCreator {
    public create(id: string): SlideComponentHkcsQ3 {
        return {
            id: id,
            type: 'hkcsQ3',
            pos: {
                x: 0,
                y: 0,
            },
            size: {
                width: 200,
                height: 200,
            },
            content: {
                image: '',
                characterList: [],
                character: 0,
                characterSound: {
                    jyutping: [],
                    pinyin: [],
                },
                phrase: '',
                phraseSound: {
                    jyutping: [],
                    pinyin: [],
                },
                phraseSoundGroup: {
                    jyutping: [],
                    pinyin: [],
                },
                imageURL: '',
                flip: 1,
                characterOptions: [],
            },
        };
    }
}
